module.exports = __webpack_public_path__ + "img/virtual.b05204da.png";